module.exports = __webpack_public_path__ + "images/emoji/earth_americas.97040812db13f06f78c7.png";